import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import Button from '@atlaskit/button/standard-button';

import { buildCreationLink } from '@confluence/create-blank-fabric-page';

const i18n = defineMessages({
	createPage: {
		id: 'home.home-views.create-page',
		defaultMessage: 'Create a page',
		description: 'Text of a button which, when clicked, creates a page',
	},
});

export const CreatePageButton = ({ appearance, creationLinkSource }) => {
	const creationHref = buildCreationLink({
		contentType: 'page',
		source: creationLinkSource,
		withFallback: true,
	});

	return (
		<Button href={creationHref} appearance={appearance} shouldFitContainer={false}>
			<FormattedMessage {...i18n.createPage} />
		</Button>
	);
};
